"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectInputComponent = exports.SelectInputState = exports.Style = exports.CSS = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var theme_1 = require("../theme");
var input_state_1 = require("./input.state");
exports.CSS = {
    container: 'c-Select',
    buttonContainer: 'c-Select__container',
    option: 'c-Select__option',
    label: 'c-Select__label',
    button: 'c-Select__button',
    error: 'c-Select__error',
    buttonDropDown: 'c-Select__drop',
    buttonText: 'c-Select__text',
    native: 'c-Select__native',
    isFullWidth: 'c-Select--full-width',
    isFocused: 'c-Select--is-focused',
    isDirty: 'c-Select--is-dirty',
    isDisabled: 'c-Select--is-disabled',
    isInvalid: 'c-Select--is-invalid',
    isOpen: 'c-Select--is-open',
    isFilled: 'c-Select--is-filled',
    isEmpty: 'c-Select--is-empty',
    MDL: {
        error: 'mdl-textfield__error',
        label: 'mdl-textfield__label',
        labelFloating: 'mdl-textfield--floating-label',
        button: 'mdl-button',
        isFocused: 'is-focused',
        isDirty: 'is-dirty',
        isUpgraded: 'is-upgraded',
        isInvalid: 'is-invalid'
    }
};
var padding = function (top, right, bottom, left) { return "".concat(theme_1.DefaultTheme.space(top), " ").concat(theme_1.DefaultTheme.space(right), " ").concat(theme_1.DefaultTheme.space(bottom), " ").concat(theme_1.DefaultTheme.space(left)); };
exports.Style = (_a = {},
    _a[exports.CSS.container] = {
        'background-image': "url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='10' height='5' viewBox='7 10 10 5' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill='%230' fill-rule='evenodd' opacity='.54' d='M7 10l5 5 5-5z'/%3E%3C/svg%3E\")",
        'background-repeat': 'no-repeat',
        'box-sizing': 'border-box',
        'background-position': 'right 8px bottom 16px',
        position: 'relative',
        width: '300px',
        'max-width': '100%',
        height: '56px'
    },
    _a[exports.CSS.container + ' .' + exports.CSS.label] = {
        color: theme_1.DefaultTheme.font.color.disabled,
        'text-overflow': 'ellipsis',
        'font-weight': 'normal'
    },
    _a[exports.CSS.native] = {
        'background-color': 'transparent',
        'font-family': theme_1.DefaultTheme.font.family,
        color: theme_1.DefaultTheme.font.color.supporting,
        outline: 'none',
        'white-space': 'nowrap',
        cursor: 'pointer',
        border: 'none',
        'border-bottom': '1px solid ' + theme_1.DefaultTheme.font.color.divider,
        padding: padding(6, 6, 1, 0),
        'line-height': '1.75rem',
        'font-size': '1rem',
        appearance: 'none', // Hide drop-down button
        width: '100%',
        '&::-ms-expand': {
            display: 'none' // Hide drop-down button for IE11
        }
    },
    _a[exports.CSS.isDisabled] = {
        cursor: 'default',
        pointerEvents: 'none',
        opacity: 0.3
    },
    _a);
(0, theme_1.addStyles)(exports.Style);
var SelectInputState = /** @class */ (function (_super) {
    tslib_1.__extends(SelectInputState, _super);
    function SelectInputState(label) {
        var _this = _super.call(this, label) || this;
        _this.isOpen = false;
        _this.required = false;
        _this.options = mobx_1.observable.array([], { deep: false });
        return _this;
    }
    SelectInputState.prototype.addOption = function (option) {
        this.options.push(option);
    };
    SelectInputState.prototype.setOptions = function (options) {
        this.options.replace(options);
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], SelectInputState.prototype, "isOpen", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SelectInputState.prototype, "required", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], SelectInputState.prototype, "addOption", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SelectInputState.prototype, "setOptions", null);
    return SelectInputState;
}(input_state_1.InputState));
exports.SelectInputState = SelectInputState;
exports.SelectInputComponent = {
    view: function (state) {
        var className = exports.CSS.container + ' ' + exports.CSS.MDL.labelFloating;
        if (state.isFilled) {
            className += ' ' + exports.CSS.isFilled;
            className += ' ' + exports.CSS.MDL.isDirty;
        }
        else {
            className += ' ' + exports.CSS.isEmpty;
        }
        if (state.focused) {
            className += ' ' + exports.CSS.isFocused;
            className += ' ' + exports.CSS.MDL.isFocused;
        }
        if (state.disabled) {
            className = "".concat(className, " ").concat(exports.CSS.isDisabled);
        }
        var EMPTY_VALUE = state.id + '-empty';
        var options = !state.required
            ? [(0, mithril_1.m)('option', { selected: true, value: EMPTY_VALUE })]
            : [];
        for (var _i = 0, _a = state.options; _i < _a.length; _i++) {
            var opt = _a[_i];
            options.push((0, mithril_1.m)('option', { className: exports.CSS.option, value: opt.value, selected: opt.value === state.value }, opt.key));
        }
        return (0, mithril_1.m)('div', { className: className }, [
            state.isLabelShown ? (0, mithril_1.m)('label', { className: exports.CSS.label + ' ' + exports.CSS.MDL.label, title: (0, i18n_1.Translate)(state.label) }, (0, i18n_1.Translate)(state.label)) : null,
            (0, mithril_1.m)('select', {
                className: exports.CSS.native,
                onchange: function (e) {
                    var target = e.target;
                    var value = target.value;
                    if (value === EMPTY_VALUE) {
                        state.setValue(null);
                    }
                    else {
                        state.setValue(value);
                    }
                },
                onfocus: function (e) { return state.setFocused(true); },
                onblur: function (e) { return state.setFocused(false); },
                disabled: state.disabled
            }, options)
        ]);
    }
};
//# sourceMappingURL=input.select.js.map